import React from 'react'
import { Table } from 'antd'
import { observer } from 'mobx-react-lite'
import { ReportsStore } from 'store/reports.store'
import { columns } from './anomalies-columns'

export const AnomaliesReportFeature = observer(() => (
  <Table
    columns={columns}
    dataSource={ReportsStore.anomaliesReport}
    pagination={false}
  />
))
